const Languages = [
    { label: "Bangla", value: "bn" },
    { label: "English", value: "en" },
    { label: "Gujarati", value: "gu" },
    { label: "Hindi", value: "hi" },
    { label: "Kannada", value: "kn" },
    { label: "Malayalam", value: "ml" },
    { label: "Marathi", value: "mr" },
    { label: "Odia", value: "or" },
    { label: "Punjabi", value: "pa" },
    { label: "Sanskrit", value: "sa" },
    { label: "Tamil", value: "ta" },
    { label: "Telugu", value: "te" },
    { label: "Urdu", value: "ur" },
  ];


  export default Languages;